exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DX8NG{padding:0 0 144px!important;padding:0 0 9rem!important}._3F6d0{height:400px;width:100%}._sp9q{display:inline-block}._2Cpj0{padding-top:64px;padding-top:4rem;padding-left:128px;padding-left:8rem;width:100%;background-color:#fff}._2K8RJ{background-image:url(\"http://image.flaticon.com/icons/svg/252/252025.svg\")}", ""]);

// exports
exports.locals = {
	"noPadding": "DX8NG",
	"mapWrapper": "_3F6d0",
	"editTestimonialView": "_sp9q",
	"wrapper": "_2Cpj0",
	"markerImage": "_2K8RJ"
};